import styled from "styled-components";

const Container = styled.div`
max-width: 1200px;
margin: 0 auto;
border-right: 1px solid #eeeeee;
`;

const VerticalLine = () => {
  return (
    <Container>
    </Container>
  );
};

export default VerticalLine;